import { animate, style, transition, trigger } from '@angular/animations';

export const expandCollapse = [
  trigger('expandCollapse', [
    transition(':enter', [
      style({
        height: '0px',
        overflow: 'hidden'
      }),
      animate(300)
    ]),
    transition(':leave', [
      style({ overflow: 'hidden' }),
      animate(300, style({
        height: '0px',
        overflow: 'hidden'
      }))
    ])
  ])
];
